/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep, sortBy } from 'lodash';
import Draggable from 'vuedraggable';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';

const __vue_script__ = {
    name: 'CustomColumnsButton',

    components: {
        Draggable,
        Checkbox,
        SearchBar
    },

    props: {
        eid: {
            type: String,
            required: true
        },

        columns: {
            type: Array,
            required: true
        },

        settingsKey: {
            type: String,
            required: true
        },

        selectedFields: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            open: false,
            fields: [],
            displayFields: [],
            mandatoryFields: [],
            searchTerm: '',
            selectAll: false
        };
    },

    watch: {
        columns: {
            immediate: true,
            handler() {
                this.init();
            }
        },

        searchTerm(newTerm, oldTerm) {
            if (newTerm && !oldTerm) {
                // keep the order of fields
                this.fields = this.displayFields;
            }
            this.displayFields = this.fields.filter(f => !newTerm || f.label.toLowerCase().includes(newTerm.toLowerCase()));
        }
    },

    methods: {
        init() {
            const fields = cloneDeep(this.columns);

            for (const field of fields) {
                field.selected = this.selectedFields.includes(field.field);
            }

            this.mandatoryFields = this.columns.filter(c => c.link).map(c => c.field);
            this.selectAll = fields.every(f => f.selected);
            this.fields = sortBy(fields, f => {
                const idx = this.selectedFields.indexOf(f.field);
                return idx === -1 ? Infinity : idx;
            });
            this.displayFields = [...this.fields];
        },

        onSelectAllChange() {
            for (const field of this.fields) {
                if (!this.mandatoryFields.includes(field.field)) {
                    field.selected = this.selectAll;
                }
            }
        },

        onItemSelectionChange(selected) {
            if (this.selectAll && !selected) {
                this.selectAll = false;
            } else if (selected && this.fields.every(f => f.selected)) {
                this.selectAll = true;
            }
        },

        onDndEnd() {
            this.fields = this.displayFields;
        },

        async save() {
            const toSave = this.fields.filter(f => f.selected).map(f => f.field);

            try {
                console.info('[CustomColumnsButton] Saving selected fields', this.settingsKey, toSave);
                await this.$services.settings.saveSetting(this.eid, this.settingsKey, toSave);

                this.$emit('columns', toSave);
            } catch (error) {
                console.error('[CustomColumnsButton] Failed to save selected fields', error);
                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000
                });
            }

            this.open = false;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-columns-button" },
    [
      _c(
        "div",
        {
          staticClass: "btn btn-default",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.open = !_vm.open
            },
          },
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("listings.custom_columns.button_label"))),
          ]),
        ]
      ),
      _c("v-popover", {
        ref: "popover",
        attrs: {
          trigger: "manual",
          "auto-hide": false,
          open: _vm.open,
          placement: "bottom",
          "popover-class": "custom-columns-popover",
        },
        scopedSlots: _vm._u([
          {
            key: "popover",
            fn: function (ref) {
              return [
                _c("header", [
                  _c(
                    "a",
                    {
                      staticClass: "close",
                      on: {
                        click: function ($event) {
                          _vm.open = false
                        },
                      },
                    },
                    [_c("i", { staticClass: "ic-x" })]
                  ),
                  _c("h2", [
                    _vm._v(
                      _vm._s(_vm.$t("listings.custom_columns.popover_title"))
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "search" },
                  [
                    _c("search-bar", {
                      attrs: { "show-no-result": false },
                      model: {
                        value: _vm.searchTerm,
                        callback: function ($$v) {
                          _vm.searchTerm = $$v
                        },
                        expression: "searchTerm",
                      },
                    }),
                  ],
                  1
                ),
                !_vm.searchTerm
                  ? _c(
                      "div",
                      { staticClass: "select-all" },
                      [
                        _c("checkbox", {
                          attrs: {
                            label: _vm.$t("listings.custom_columns.select_all"),
                            name: "select-all",
                          },
                          on: { input: _vm.onSelectAllChange },
                          model: {
                            value: _vm.selectAll,
                            callback: function ($$v) {
                              _vm.selectAll = $$v
                            },
                            expression: "selectAll",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.displayFields.length
                  ? _c(
                      "draggable",
                      {
                        staticClass: "field-list",
                        attrs: { filter: ".disabled" },
                        on: { end: _vm.onDndEnd },
                        model: {
                          value: _vm.displayFields,
                          callback: function ($$v) {
                            _vm.displayFields = $$v
                          },
                          expression: "displayFields",
                        },
                      },
                      _vm._l(_vm.displayFields, function (field) {
                        return _c(
                          "div",
                          {
                            key: field.field,
                            staticClass: "field-item",
                            class: { disabled: _vm.searchTerm },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "selected" },
                              [
                                _c("checkbox", {
                                  attrs: {
                                    disabled: _vm.mandatoryFields.includes(
                                      field.field
                                    ),
                                    name: "selected",
                                  },
                                  on: { input: _vm.onItemSelectionChange },
                                  model: {
                                    value: field.selected,
                                    callback: function ($$v) {
                                      _vm.$set(field, "selected", $$v)
                                    },
                                    expression: "field.selected",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "field-name" }, [
                              _vm._v(_vm._s(field.label)),
                            ]),
                            _c("div", { staticClass: "drag-handler" }, [
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.searchTerm,
                                    expression: "!searchTerm",
                                  },
                                ],
                                staticClass: "icon-reorder",
                              }),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.searchTerm && !_vm.displayFields.length
                  ? _c("div", { staticClass: "empty-search" }, [
                      _c("div", { staticClass: "icon" }, [
                        _c("i", { staticClass: "ic-search" }),
                      ]),
                      _c("div", { staticClass: "message" }, [
                        _vm._v(
                          _vm._s(_vm.$t("listings.custom_columns.empty_search"))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("footer", [
                  _c("div", { staticClass: "actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.open = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.save },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.apply")))]
                    ),
                  ]),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/listings/CustomColumnsButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__